module.exports = __webpack_public_path__ + "static/EmbedMod-03-76645d12fef4366f90246e93523988b8.png";